/**
 * Highlight active nav link on homepage scroll
 */
export function initNavScrollSpy() {
  const nav = document.querySelector('#main-navbar');
  if (!nav || (!document.querySelector('.home-page') && !document.querySelector('.mkt'))) return;

  const links = nav.querySelectorAll('.nav-pills .nav-link[href*="#"]');
  if (!links.length) return;

  const sections = [];
  links.forEach((link) => {
    const hash = link.getAttribute('href')?.split('#')[1];
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) sections.push({ id: hash, el, link });
  });

  if (!sections.length) return;

  const setActive = (id) => {
    links.forEach((l) => l.classList.remove('active'));
    const match = sections.find((s) => s.id === id);
    match?.link.classList.add('active');
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
        .forEach((e) => setActive(e.target.id));
    },
    { rootMargin: '-40% 0px -45% 0px', threshold: [0, 0.25, 0.5] }
  );

  sections.forEach(({ el }) => observer.observe(el));
}
